module.exports = __webpack_public_path__ + "static/media/message.mp3?5e3ad7b71f4af6a040ab9da72585bc02";